import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Loader } from '@resy/ui-kitchen';
import VenueList from '../../VenueList';
import transformSlots from '../../../../../../ui-kitchen/src/transformers/transformSlots';
import transformVenues from '../../../../../../ui-kitchen/src/transformers/transformVenues';
import { getVenuesBookTonight } from '../../../../../../ui-kitchen/src/api/api';
import MultiStepListModal from '../../../../../../ui-kitchen/src/components/MultiStepListModal';
import { ALL_DAY } from '../../../../../../ui-kitchen/src/constants/resyCore';
import Logger from '../../../../../../ui-kitchen/src/utils/logger';
import { AMEX_UTM_SOURCE, AMEX_DELTA_UTM_MEDIUM, AMEX_DELTA_UTM_BOOKING_CAMPAIGN } from '../../AmexMarketingUtils/constants';

import './DeltaWifiBookNow.scss';

class DeltaWifiBookNow extends React.Component {
    static propTypes = {
      $rootScope: PropTypes.shape(PropTypes.object.isRequired).isRequired,
      event: PropTypes.func.isRequired,
      loadNotifyModal: PropTypes.func.isRequired,
      latLng: PropTypes.shape({
        value: PropTypes.string,
      }),
      selectedDate: PropTypes.string,
      selectedSeats: PropTypes.number,
      selectedTime: PropTypes.string,
      cityCode: PropTypes.string.isRequired,
      cityName: PropTypes.string.isRequired,
      citySlug: PropTypes.string.isRequired,
      isAuthenticated: PropTypes.bool.isRequired,
      bookNowConfig: PropTypes.shape({
        name: PropTypes.string,
        no_venues_text: PropTypes.string,
        market: PropTypes.shape({
          api_limit: PropTypes.number,
          grid_limit: PropTypes.number,
          title: PropTypes.string,
        }),
        agnostic: PropTypes.shape({
          api_limit: PropTypes.number,
          grid_limit: PropTypes.number,
          title: PropTypes.string,
        }),
      }).isRequired,
      isAgnostic: PropTypes.bool.isRequired,
      isMobile: PropTypes.bool.isRequired,
      matchMedia: PropTypes.shape({
        xs: PropTypes.bool,
        sm: PropTypes.bool,
        md: PropTypes.bool,
        lg: PropTypes.bool,
        xl: PropTypes.bool,
      }).isRequired,
      Analytics: PropTypes.shape({
        event: PropTypes.func.isRequired,
      }).isRequired,
      showAuthModal: PropTypes.func.isRequired,
    }

    static defaultProps = {
      latLng: undefined,
      selectedDate: null,
      selectedSeats: 2,
      selectedTime: '',
    }

    state = {
      venuesList: null,
      hasNoResults: true,
      loading: false,
    }

    componentDidMount() {
      const {
        cityCode,
      } = this.props;
      if (cityCode) this.fetchBookNowVenues();
    }

    // eslint-disable-next-line no-unused-vars
    componentDidUpdate(prevProps) {
      const {
        selectedDate, selectedSeats, isAuthenticated, cityCode, selectedTime,
      } = this.props;
      if (prevProps.selectedDate !== selectedDate || prevProps.selectedSeats !== selectedSeats || prevProps.selectedTime !== selectedTime
        || prevProps.isAuthenticated !== isAuthenticated || (cityCode && prevProps.cityCode !== cityCode)) {
        if (cityCode) {
          this.setLoading();
          this.fetchBookNowVenues();
        }
      }
    }

    setLoading = () => {
      this.setState({ loading: true });
    }

     processVenueData = (data) => {
       if (!data) return null;

       return data.reduce(
         (results, venue) => {
           results.push(
             {
               ...venue,
               slots: transformSlots(venue.slots, { gatingErrors: venue.gating_errors }),
               venue: transformVenues(venue),
             }
           );
           return results;
         }, []
       );
     };

  fetchBookNowVenues = async () => {
    const {
      latLng,
      cityCode,
      selectedDate,
      selectedSeats,
      isAuthenticated,
      bookNowConfig,
      isAgnostic,
      selectedTime,
    } = this.props;
    const [lat, long] = latLng?.value.split(',');

    const payload = {
      location: cityCode,
      day: selectedDate,
      party_size: selectedSeats,
      lat,
      long: long.trim(),
      limit: isAgnostic ? bookNowConfig.agnostic.api_limit : bookNowConfig.market.api_limit,
      offset: 1,
      finder: 4,
      isAuth: isAuthenticated,
      time_filter: selectedTime === ALL_DAY ? undefined : moment(selectedTime, 'HHmm').format('HH:mm'),
    };

    try {
      const response = await getVenuesBookTonight(payload);
      if (response?.results?.venues?.length > 0) {
        this.setState({ venuesList: this.processVenueData(response?.results?.venues), hasNoResults: false });
        this.setState({ hasNoResults: false, loading: false });
      } else {
        this.setState({ hasNoResults: true, loading: false });
      }
    } catch (err) {
      this.setState({ hasNoResults: true });
      Logger.error('[ERROR] DeltaWifiBookNow Component', err);
    }
  };

  render() {
    const {
      $rootScope,
      cityName,
      cityCode,
      citySlug,
      event,
      loadNotifyModal,
      selectedDate,
      selectedSeats,
      isMobile = false,
      isAgnostic,
      bookNowConfig,
      matchMedia,
      Analytics,
      showAuthModal,
    } = this.props;

    const { hasNoResults, loading } = this.state;

    const tagBooking = {
      utm: {
        utm_source: AMEX_UTM_SOURCE,
        utm_medium: AMEX_DELTA_UTM_MEDIUM,
        utm_campaign: AMEX_DELTA_UTM_BOOKING_CAMPAIGN,
      },
    };

    const { venuesList } = this.state;
    if (!cityCode) {
      return null;
    }

    const { title: titleDisplay, grid_limit: maxCards } = isAgnostic ? bookNowConfig?.agnostic
      : bookNowConfig?.market;

    let venuesLength = 0;
    if (maxCards < venuesList?.length) {
      venuesLength = maxCards;
    } else {
      venuesLength = venuesList?.length;
    }

    const renderLoading = (
      <div>
        <Loader className="DeltaWifiBookNow__loader" />
      </div>
    );

    return (
      <section
        className={cx('DeltaWifiBookNow__section', {
          market: (!isAgnostic),
          agnostic: (isAgnostic),
        })}
        id="booknow"
      >
        {loading && renderLoading}
        <article className="DeltaWifiBookNow__wrapper">
          {!loading && !hasNoResults && (
            <>
              <VenueList
                $rootScope={$rootScope}
                hasNoResults={hasNoResults}
                name={`${titleDisplay} ${cityName}`}
                restaurants={venuesList}
                selectedDate={selectedDate}
                selectedSeats={selectedSeats}
                loadNotifyModal={loadNotifyModal}
                locationCode={cityCode}
                locationSlug={citySlug}
                event={event}
                showSeeMore
                maxCards={maxCards}
                deltaWifiVenuelength={venuesLength}
                isDeltaWifi
                tagBooking={tagBooking}
                matchMedia={matchMedia}
                isMobile={isMobile}
                showCarouselButtons={venuesList.length > maxCards}
                showAuthModal={showAuthModal}
              />
              <MultiStepListModal Analytics={Analytics} />
            </>
          )}
          {!loading && hasNoResults
            && (
              <div className="DeltaWifiBookNow__wrapper--error">
                <div className="container">
                  <div className="CollectionHeadline__content">
                    <h2 className="CollectionHeadline__title">
                      {`${titleDisplay} ${cityName}`}
                    </h2>
                  </div>
                  <div className="DeltaWifiBookNow__content--dynamic-error">
                    {bookNowConfig?.no_venues_text}
                  </div>
                </div>
              </div>
            )}
        </article>
      </section>
    );
  }
}

export default DeltaWifiBookNow;
